<script setup lang="ts">
import {PropType, ref} from "vue";
import {odsPill, PillTheme} from "../../components/odsPill";
import {odsFieldMessage} from "../../components/odsFieldMessage/";
import {Spacing} from "../../tokens";

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  defaultValue: {
    type: String,
    default: '',
  },
  message: {
    type: String,
    default: '',
  },
  messageTheme: {
    type: String as PropType<typeof PillTheme[keyof typeof PillTheme]>,
    default: PillTheme.Default,
  },
  validators: {
    type: Array as PropType<{ label: string; theme: (value: string) => PillTheme; }[]>,
    default: [],
  },
  options: {
    type: Array as PropType<{ label: string; value: any; default?: boolean; }[]>,
    required: true,
  },
  padding: {
    type: String as PropType<typeof Spacing[keyof typeof Spacing]>,
    default: Spacing.Standard,
  }
});

const value = ref(props.options?.find(option => option.default)?.value);

const input = ref();
</script>

<template>
  <div
      class="ods-select"
      :class="[{disabled, error: messageTheme === PillTheme.Failure, warning: messageTheme === PillTheme.Warning}]"
  >
    <label v-if="label" v-html="label" :for="id"/>
    <select
        :id="id"
        @change.stop="$emit('change', value)"
        v-model="value"
        ref="input"
        :class="[`ods-padding-${padding}`, {disabled}]"
        :disabled="disabled"
    >
      <option
          v-for="(option, index) of options"
          :key="index"
          :value="option.value"
          v-html="option.label"
      />
    </select>
    <div v-if="validators.length > 0" class="conditions">
      <odsPill
          v-for="(validator, index) of validators"
          :key="index"
          :theme="validator.theme(value)"
          :label="validator.label"
      />
    </div>
    <odsFieldMessage
        :message="message"
        :message-theme="messageTheme"
    />
  </div>
</template>

<style lang="scss" src="./odsSelect.scss"/>